import React from 'react';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import Vmails from './Vmails';
import SortIcons from './ProposalsSortIcons';
const VmailsList = ({
  vmails,
  onDownload,
  onDelete,
  user,
  deleteMode,
  onRecover,
  onSort,
  sortValue,
}) => {
  return (
    <div className="table-header-fixed">
      <table className="provisionList">
        <thead>
          <tr>
            <th
              className="cursor-pointer"
              onClick={() => vmails.length > 0 && onSort('company[name]')}
            >
              Company <SortIcons sortObj={sortValue} sortName="company[name]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => vmails.length > 0 && onSort('user[email]')}
            >
              Email <SortIcons sortObj={sortValue} sortName="user[email]" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => vmails.length > 0 && onSort('receivedOn')}
            >
              Received On <SortIcons sortObj={sortValue} sortName="receivedOn" />
            </th>
            <th
              className="cursor-pointer"
              onClick={() => vmails.length > 0 && onSort('receivedFrom')}
            >
              Received From <SortIcons sortObj={sortValue} sortName="receivedFrom" />
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {vmails.length ? (
            vmails.map(vmail => (
              <Vmails
                deleteMode={deleteMode}
                onRecover={onRecover}
                key={vmails._id}
                vmails={vmail}
                onDelete={onDelete}
                onDownload={onDownload}
              />
            ))
          ) : (
            <tr>
              <td colSpan={12}>
                <Alert rowSpan={12} color="info">
                  No Voice Mails Found
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(VmailsList);
